import LayerGroup from "ol/layer/Group";
import LayerTile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

const karagatanURL = process.env.GEOSERVER;
const attEOG =
  '<a href="https://eogdata.mines.edu/vbd/">Earth Observation Group, Payne Institute for Public Policy</a>';

const iuuf_2026Q1 = new LayerGroup({
  title: "2026 Q1",
  fold: "close",
  layers: [
    ///////////monthly

    new LayerTile({
      title: "Triple/Quadruple Nets",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_Superlight",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Superlight",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_Superlight",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Ring Net (Likom-Likom/Basnig)",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_RingNet",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Obnoxious Substances",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_PoisonFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Modified Danish Seine (Liba-Liba)",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_ModifiedDanishSeine",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Mangrove Cutting",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_MangroveCutting",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Illegal Structures in the Shoreline",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_IllegalStructuresInTheShoreline",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Fishing Inside Marine Sanctuary",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_FishingInsideMarineSanctuary",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Fine Mesh Net Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_FineMeshNetFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Dynamite Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_DynamiteFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Compressor Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_CompressorFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Blast Fishing",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_BlastFishing",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
      }),
    }),
    new LayerTile({
      title: "Bagnet",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026Q1_Bagnet",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
  ],
});

export default iuuf_2026Q1;
